import { render, staticRenderFns } from "./SigCapt.vue?vue&type=template&id=58dfd72c&scoped=true"
import script from "./SigCapt.vue?vue&type=script&lang=js"
export * from "./SigCapt.vue?vue&type=script&lang=js"
import style0 from "./SigCapt.vue?vue&type=style&index=0&id=58dfd72c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dfd72c",
  null
  
)

export default component.exports